'use strict';
import axios from 'axios';
import store from 'components/store.js';

//Fetching the data from store.
const GetCustomerQueryParams = () => {

  const state = { ...store.getState() };//avoid bugs with immutable data
  const UserId = parseInt(state.userid);
  const RoleId = parseInt(state.roleId);
  const AccessToken = state.accessToken;

  const queryParams = {
    "user_id": UserId,
    "access_token": AccessToken,
    "role_id": RoleId
  };
  return queryParams;
}

/*************************************************************************/
/*              APIs for Customers
*************************************************************************/

// export const getCustomers = () => {
//     let urlstr = `/api/customers/admin/customer-details/all`;
//     let queryParams = GetCustomerQueryParams();
//     let dataQuery = Object.assign(queryParams);
//     return  axios.get(urlstr, dataQuery)
//       .then(resp => resp.data.payload);
// }

export const getCustomers = () => {
  let urlstr = `/api/customers/admin/customer-details/all`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}

export const getBilledCustomers = () => {
  let urlstr = `/api/customers/admin/customer-details/billed`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}

export const getDemoCustomers = () => {
  let urlstr = `/api/customers/admin/customer-details/demo`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}


export const activateCustomerAccount = (customerId) => {
  const url = `/api/customers/admin/customer-details/update-account-status/${customerId}/activate`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(url, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  }).then(resp => resp.data.payload);
};

export const deactivateCustomerAccount = (customerId) => {
  const url = `/api/customers/admin/customer-details/update-account-status/${customerId}/deactivate`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(url, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  }).then(resp => resp.data.payload);
};

export const setCustomerAccountTypeToDemo = (customerId) => {
  const url = `/api/customers/admin/customer-details/update-account-type/${customerId}/demo`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(url, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  }).then(resp => resp.data.payload);
};

export const setCustomerAccountTypeToBilled = (customerId) => {
  const url = `/api/customers/admin/customer-details/update-account-type/${customerId}/billed`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(url, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  }).then(resp => resp.data.payload);
};

export const getProductTypes = () => {
  let urlstr = `/api/customers/admin/mavric-product-types/all`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr,
    {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery)
      }
    })
    .then(resp => resp.data.payload);
}

export const updateCustProductTypes = (id, mavric_product_id) => {
  let urlstr = `/api/customers/admin/customer-details/update-product-type/${id}/${mavric_product_id}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, {},
    {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery)
      }
    })
    .then(resp => resp.data.payload);
}

export const resetPassword = (newPassword, currentPassword) => {
  const urlstr = `/api/customers/admin/reset-password`;
  const dataPayload = {
    new_password: newPassword,
    current_password: currentPassword
  };
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, dataPayload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}

export const addNewCustomer = (payload) => {
  // const { org_name, product_type, act_type } = payload;
  // const product_id = product_type === 'mavric-cloud' ? 1 : 2;
  let urlstr = `/api/customers/admin/customers/new`;
  // let dataPayload = {
  //   org_name,
  //   product_id,
  //   act_type
  // };
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, payload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data.payload);
}

export const getProbeListByCustomerId = (customerId) => {
  let urlstr = `/api/customers/admin/probes/${customerId}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}


export const getAuthProviders = () => {
  let urlstr = `/api/customers/sso-authproviders-supported`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}


export const updateAuthProviderByCustomerId = (customerId, authProvider, identityProvider, app) => {
  let urlstr = `/api/customers/admin/customer-details/update-sso-authprovider/${authProvider.toLowerCase()}/${customerId}/${app}`;
  let dataPayload = identityProvider;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, dataPayload,
    {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery)
      }
    })
    .then(resp => resp.data.payload);
}

export const getSSOProviderHistory = (customerId, app, provider) => {
  const urlstr = `/api/customers/admin/customer-details/sso-authprovider/${customerId}/${app}/history/${provider.toLowerCase()}`;
  // api/customers/admin/customer-details/sso-authprovider/5/web/history/azuread
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  }).then(resp => resp.data.payload);
};

export const getAuthProviderByCustomerId = (customerId, app) => {
  let urlstr = `/api/customers/admin/customer-details/sso-authprovider/${customerId}/${app}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data.payload)
};


export const disableSSOProviderByCustomerId = (customerId, app) => {
  let urlstr = `/api/customers/admin/customer-details/disable-sso/${customerId}/${app}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  }).then(resp => resp.data.payload);
}


export const getUserRoles = () => {
  let urlstr = `/api/customers/admin/customer-details/userroles/all`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}


export const getWohlerUserRoles = () => {
  let urlstr = `/api/customers/admin/wohler-user-roles/all`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);

  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}

export const getAllUsers = () => {
  let urlstr = `/api/customers/admin/usermgmt/wx/users/all`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}

export const addNewAdminPortalUser = (userData) => {
  let dataPayload = userData;
  let urlstr = `/api/customers/admin/usermgmt/wx/users/new`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);

  return axios.post(urlstr, dataPayload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data.payload);
}

export const resetPortalUserPassword = (userData) => {
  let dataPayload = { 'password': userData.new_password };
  let userId = userData.user_id;
  let urlstr = `/api/customers/admin/usermgmt/wx/users/resetpassword/${userId}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);

  return axios.post(urlstr, dataPayload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data);
};


export const deleteAdminPortalUser = (userId) => {
  const urlstr = `/api/customers/admin/usermgmt/wx/users/delete/${userId}`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(urlstr, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data);
}

export const editAdminPortalUser = (userId, userData) => {
  const dataPayload = userData;
  const urlstr = `/api/customers/admin/usermgmt/wx/users/edituserdetails/${userId}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);

  return axios.post(urlstr, dataPayload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
};


export const addNewMonitoringUser = (monitorinUsrData) => {
  let dataPayload = monitorinUsrData;
  let customerId = monitorinUsrData.customer_id;
  let urlstr = `/api/customers/admin/customer-details/${customerId}/newuser`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, dataPayload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data.payload);
}


export const getMonitorUserListByCustomerId = (customerId) => {
  let urlstr = `/api/customers/admin/customer-details/users/all/${customerId}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}

export const updateMonitoringUserByCustomerId = (monitorUsrData) => {
  let dataPayload = monitorUsrData;
  let customerId = monitorUsrData.customer_id;
  let userId = monitorUsrData.user_id;
  let urlstr = `/api/customers/admin/customer-details/edituser/${customerId}/${userId}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, dataPayload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data.payload);
}

export const resetMonitorUserPassword = (monitorUsrData) => {
  let dataPayload = { 'password': monitorUsrData.new_password };
  let customerId = monitorUsrData.customer_id;
  let userId = monitorUsrData.user_id;
  let urlstr = `/api/customers/admin/customer-details/resetpassword/${customerId}/${userId}`;

  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);

  return axios.post(urlstr, dataPayload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data);
}


export const deleteMonitoringUserByCustomerId = (customerId, userId) => {
  let urlstr = `/api/customers/admin/customer-details/deleteuser/${customerId}/${userId}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data);
}


export const deleteCustomer = (customerId) => {
  let urlstr = `/api/customers/admin/customers/delete/${customerId}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data);
}

export const deleteProbe = (probeSerialNum) => {
  let urlstr = `/api/customers/admin/probes/deleteprobe/${probeSerialNum}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.post(urlstr, {}, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })
    .then(resp => resp.data);
}

export const searchProbe = (probeserialnumber) => {
  let urlstr = `/api/customers/admin/probes/findprobe/${probeserialnumber}`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr,
    {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery)
      }
    })
    .then(resp => resp.data);
}

export const getMavricTokenTemplate = () => {
  let urlstr = `/api/customers/admin/mavric-token-template`;
  let queryParams = GetCustomerQueryParams();
  let dataQuery = Object.assign(queryParams);
  return axios.get(urlstr, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery)
    }
  })
    .then(resp => resp.data.payload);
}

export const postMavricTokenTemplate = (payload) => {
  const url = `/api/customers/admin/mavric-token-template`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(url, payload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};


export const getLiveViewerData = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/liveinfo/all`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};

export const getProbeStreamingActivity = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/probestreaming/thismonth`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};

export const getProbeStreamingActivityForLastMonth = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/probestreaming/lastmonth`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};

export const getProbeStreamingAll = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/probestreaming/all`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};

export const getProbeViewerActivityForThisMonth = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/probeviewers/thismonth`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};


export const getProbeViewerActivityForLastMonth = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/probeviewers/lastmonth`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};

export const getProbeViewersAll = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/probeviewers/all`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};

export const getReportTypes = () => {
  const url = `/api/customers/admin/customer-details/streamactivities/reporttypes`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};


export const downloadProbeStreamingReport = async (payload) => {
  const url = `/api/customers/admin/customer-details/streamactivities/probestreaming/report`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  try {
    const response = await axios.post(url, payload,
      {
        headers: {
          'Content-Type': 'application/json',
          data: JSON.stringify(dataQuery),
        },
        responseType: 'blob'
      }
    );

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};


export const downloadProbeViewersReport = async (payload) => {
  const url = `/api/customers/admin/customer-details/streamactivities/probeviewers/report`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  try {
    const response = await axios.post(url, payload,
      {
        headers: {
          'Content-Type': 'application/json',
          data: JSON.stringify(dataQuery),
        },
        responseType: 'blob'
      }
    );

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const getDataconsumptionReportTypes = () => {
  const url = `/api/customers/admin/customer-details/dataconsumption/reporttypes`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
    .then(resp => resp.data.payload);
};

export const getDataConsumptionView = (customerId, reportParams = {}) => {
  // const url = `/api/customers/admin/customer-details/dataconsumption/view`;
  const url = `/api/customers/admin/customer-details/dataconsumption/consolidated/${customerId}/view`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);
  
  // const requestBody = {
  //   query_timezone: "UTC",
  //   duration: "all",
  //   ...reportParams 
  // };

  return axios.post(url, reportParams, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    }
  })

  // return axios.get(url, {
  //   headers: {
  //     'Content-Type': 'application/json',
  //     data: JSON.stringify(dataQuery),
  //   }
  // })
  
  .then(resp => resp.data.payload);
};

export const downloadDataConsumptionReport = async (payload, customerId) => {
  // const url = `/api/customers/admin/customer-details/dataconsumption/generatereport`;
  const url = `/api/customers/admin/customer-details/dataconsumption/consolidated/${customerId}/report`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  try {
    const response = await axios.post(url, payload,
      {
        headers: {
          'Content-Type': 'application/json',
          data: JSON.stringify(dataQuery),
        },
        responseType: 'blob'
      }
    );

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};


export const getCustomerUserActivities = (payload, customerId) => {
  const { duration } = payload;
  if (!customerId) {
    throw new Error('Customer ID is required');
  }

  const url = `/api/customers/admin/customers-audit-sessions/${duration}/${customerId}/summary`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(url, payload,{
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
  .then(resp => resp.data.payload)
  .catch(error => {
    console.error(`Error fetching user activities for customer ${customerId}:`, error);
    throw error;
  });
};

export const getAllCustomerUserActivities = (period) => {
  const url = `/api/customers/admin/customers-audit-sessions/allusers/${period}/summary`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);
 
  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
  .then(resp => resp.data.payload)
  .catch(error => {
    console.error(`Error fetching user activities for all customers:`, error);
    throw error;
  });
};

export const downloadUserActivitiesReport = async (payload, customerId) => {
  const { period } = payload;
  const url = `/api/customers/admin/customers-audit-sessions/${period}/${customerId}/report`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  try {
    const response = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery),
      },
      responseType: 'blob'
    });

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};


export const getCustomerProbeActivities = (payload, customerId) => {
  const { duration } = payload;
  const url = `/api/customers/admin/customers-audit-sessions/${duration}/${customerId}/probes/stats`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.post(url, payload, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
  .then(resp => resp.data.payload)
  .catch(error => {
    console.error(`Error fetching probe activities for customer ${customerId}:`, error);
    throw error;
  });
};

export const downloadProbeActivitiesReport = async (payload, customerId) => {
  const { period } = payload;
  const url = `/api/customers/admin/customers-audit-sessions/${period}/${customerId}/probes/report`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  try {
    const response = await axios.post(url, payload,{
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery),
      },
      responseType: 'blob'
    });

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};


export const downloadAllUserActivitiesReport = async (payload) => {
  const { period } = payload;
  // const url = `/api/customers/admin/customers-audit-sessions/${period}/allusers/report`;
  const url = `/api/customers/admin/customers-audit-sessions/allusers/${period}/report`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  try {
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery),
      },
      responseType: 'blob'
    });

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const getAllProbeActivities = (period) => {
  const url = `/api/customers/admin/customers-audit-sessions/allprobes/${period}/summary`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  return axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      data: JSON.stringify(dataQuery),
    },
  })
  .then(resp => resp.data.payload)
  .catch(error => {
    console.error(`Error fetching probe activities for all customers:`, error);
    throw error;
  });
};

export const downloadAllProbeActivitiesReport = async (payload) => {
  const { period } = payload;
  const url = `/api/customers/admin/customers-audit-sessions/allprobes/${period}/report`;
  const queryParams = GetCustomerQueryParams();
  const dataQuery = Object.assign(queryParams);

  try {
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        data: JSON.stringify(dataQuery),
      },
      responseType: 'blob'
    });

    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};
